export default {
  title: {
    en: 'SHOW ONLY LIVE',
  },
}
